import { call, put, takeLatest } from "redux-saga/effects";
import {
  barMonthReportDateSearchFailure,
  barMonthReportDateSearchSuccess,
  barMonthReportFailure,
  barMonthReportSuccess,
  barReportDateSearchFailure,
  barReportDateSearchSuccess,
  barReportFailure,
  barReportSearchFailure,
  barReportSearchSuccess,
  barReportSuccess,
  barWeekReportDateSearchFailure,
  barWeekReportDateSearchSuccess,
  barWeekReportFailure,
  barWeekReportSuccess,
} from "./BarReportAction";
import {
  BarDayDateSearchReportEffect,
  BarDayReportEffect,
  BarMonthDateSearchReportEffect,
  BarMonthReportEffect,
  BarWeekDateSearchReportEffect,
  BarWeekReportEffect,
  SearchBarReportEffect,
} from "./BarReportEffect";
import {
  BAR_REPORT_DATE_MONTH_SEARCH_REQUEST,
  BAR_REPORT_DATE_SEARCH_REQUEST,
  BAR_REPORT_DATE_WEEK_SEARCH_REQUEST,
  REPORT_BAR_MONTH_REPORT_REQUEST,
  REPORT_BAR_REPORT_REQUEST,
  REPORT_BAR_REPORT_SEARCH_REQUEST,
  REPORT_BAR_WEEK_SEARCH_REQUEST,
} from "./BarReportTypes";

//Month Bar report
function* viewMonthBarReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(BarMonthReportEffect, action.payload, config);

    yield put(barMonthReportSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(barMonthReportFailure({ errormessage: errorMessage }));
  }
}

// View Week Bar report
function* viewWeekBarReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(BarWeekReportEffect, action.payload, config);

    yield put(barWeekReportSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(barWeekReportFailure({ errormessage: errorMessage }));
  }
}

// View Day Bar report
function* viewDayBarReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(BarDayReportEffect, action.payload, config);

    yield put(barReportSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(barReportFailure({ errormessage: errorMessage }));
  }
}

// View Month Search Bar report
function* viewMonthSearchBarReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      BarMonthDateSearchReportEffect,
      action.payload,
      config
    );

    yield put(barMonthReportDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(barMonthReportDateSearchFailure({ errormessage: errorMessage }));
  }
}

// View Week Search Bar report
function* viewWeekSearchBarReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      BarWeekDateSearchReportEffect,
      action.payload,
      config
    );

    yield put(barWeekReportDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(barWeekReportDateSearchFailure({ errormessage: errorMessage }));
  }
}

// View Day Date Search Bar report
function* viewDayDateSearchBarReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      BarDayDateSearchReportEffect,
      action.payload,
      config
    );

    yield put(barReportDateSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(barReportDateSearchFailure({ errormessage: errorMessage }));
  }
}

// View All Search Bar report
function* viewAllSearchBarReportSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(SearchBarReportEffect, action.payload, config);

    yield put(barReportSearchSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(barReportSearchFailure({ errormessage: errorMessage }));
  }
}

export function* BarReportSaga() {
  yield takeLatest(REPORT_BAR_MONTH_REPORT_REQUEST, viewMonthBarReportSaga);
  yield takeLatest(REPORT_BAR_WEEK_SEARCH_REQUEST, viewWeekBarReportSaga);
  yield takeLatest(REPORT_BAR_REPORT_REQUEST, viewDayBarReportSaga);
  yield takeLatest(
    BAR_REPORT_DATE_MONTH_SEARCH_REQUEST,
    viewMonthSearchBarReportSaga
  );
  yield takeLatest(
    BAR_REPORT_DATE_WEEK_SEARCH_REQUEST,
    viewWeekSearchBarReportSaga
  );
  yield takeLatest(
    BAR_REPORT_DATE_SEARCH_REQUEST,
    viewDayDateSearchBarReportSaga
  );
  yield takeLatest(
    REPORT_BAR_REPORT_SEARCH_REQUEST,
    viewAllSearchBarReportSaga
  );
}
